import MenuSelect from '../extensions/MenuSelect'
import { materialTypeLabels } from '../../constants/materialTypes'

export default function AudienceFilter() {
  return (
    <MenuSelect
      label='Material Type'
      icon='briefcase'
      attribute='type'
      transformItems={items =>
        items.map(item => ({
          ...item,
          label: materialTypeLabels[item.label],
        }))
      }
    />
  )
}
